import locale from "localization/en";

export const promosColumn = [
  {
    key: "select",
    className: "alignToTop",
    width: "50px",
    actionHeader: true,
  },
  {
    key: "promoName",
    text: locale.promoName,
    className: "alignToTop",
    width: "200px",
  },
  {
    key: "promoType",
    text: locale.promoType,
    className: "alignToTop",
    width: "100px",
  },
  {
    key: "promoCap",
    text: locale.maxDiscount,
    className: "alignToTop",
    width: "120px",
  },
  {
    key: "promoDate",
    text: locale.promoDate,
    className: "alignToTop",
    width: "110px",
  },
  {
    key: "product",
    text: (
      <span>
        {locale.product} /<br />
        {locale.promoAmount}
      </span>
    ),
    className: "alignToTop",
    // width: "10%",
  },

  // {
  //   key: "promoAmount",
  //   text: locale.promoAmount,
  //   className: "alignToTop",
  //   width: "100px",
  // },
];
